import { Component, OnInit, EventEmitter } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { TripService } from 'src/app/services/trip.service';
import { Trip } from 'src/app/_models/daws/trip';
import { DeleteRouteComponent } from './delete-route.component';
import { RouteService } from 'src/app/services/route.service';
@Component({
  selector: 'open-route',
  templateUrl: './open-route.component.html',
  styleUrls: ['./open-route.component.scss'],
})
export class OpenRouteComponent implements OnInit {
  showRouteEvent: EventEmitter<Trip> = new EventEmitter();
  deleteRouteCancelEvent = new EventEmitter();
  savedRoutes: Trip[] = null;
  selectedRoute: Trip = null;
  errorMessage = '';
  loading = true;
  mouseOverRouteId: number = null;
  constructor(
    public openRouteModalRef: BsModalRef,
    private tripService: TripService,
    private modalService: BsModalService,
    private routeService: RouteService
  ) {}
  ngOnInit(): void {
    this.getSavedRoutes();
  }

  getSavedRoutes() {
    this.tripService.getTrip().subscribe(
      (response) => {
        this.savedRoutes = response;
        this.logMinDataVersion(this.savedRoutes);
        this.loading = false;
      },
      (err) => {
        this.errorMessage = err.message; // Todo-yz
        this.errorMessage =
          'There was an error retrieving the saved routes, please try again later.';
        this.loading = false;
      }
    );
  }

  // double click or keyup.enter or open button click
  // opens the saved route in route panel and draw the route on a map.
  openRoute() {
    this.showRouteEvent.emit(this.selectedRoute);
    this.openRouteModalRef.hide();
  }

  // single click or tab focus
  selectRoute(route: Trip) {
    this.selectedRoute = route;
  }

  deleteRoute(route: Trip) {
    this.openRouteModalRef.hide();
    const modalRef = this.modalService.show(DeleteRouteComponent, {
      class: 'modal-sm, modal-dialog-centered',
      backdrop: 'static',
      initialState: { route },
    });
    modalRef.content.deleteEvent.subscribe((routeId: number) => {
      if (this.selectedRoute?.Id === routeId) {
        this.selectedRoute = null;
      }
      this.savedRoutes = this.savedRoutes.filter((r) => r.Id !== routeId);
    });

    modalRef.content.cancelEvent.subscribe(() => {
      this.deleteRouteCancelEvent.emit();
    });
  }
  mouseEnter(route: Trip) {
    this.mouseOverRouteId = route.Id;
  }
  mouseLeave() {
    this.mouseOverRouteId = null;
  }
  logMinDataVersion(data: Trip[]) {
    data.map((trip: Trip) => {
      if (trip?.Profile?.dataVersion) {
        this.routeService.logMinDataVersion(trip?.Profile?.dataVersion);
      }
      return null;
    });
  }
}
